export default __webpack_public_path__ + "static/media/pix-logo.36e005b0.svg";